import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  API_INITIATE_GET_SSM_CUSTOMER_DATA,
  API_COMPLETE_GET_SSM_CUSTOMER_DATA,
  API_INITIATE_SUBMIT_SSM_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_SSM_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_SSM_SITE_CUSTOMER_DATA,
  API_INITIATE_AUTO_SAVE,
  API_COMPLETE_AUTO_SAVE,
  INITIATE_ISDN_CALLBACK_REQUEST,
  COMPLETE_ISDN_CALLBACK_REQUEST,
} from '../../app-constants';
import { submitSSMCustomerData, submitAutoSaveData, submitIsdnRequestCallback } from './ssm-homepage.actions';
import View from './ssm-homepage.presenter';

// Reducer
export const ssmHomePageReducer = (state = {
  loading: false,
  customerAccountNumbers: [],
  customerAccountName: '',
  customerFirstName: '',
  customerLastName: '',
  customerContactPhone: '',
  sitesData: [],
  dataLoaded: false,
  siteFormSubmitted: false,
  cwpBanner: false,
  referenceNumber: '',
  siteIdSubmitted: '',
  isdnProduct: true,
  autoSaveStatus: 'No Changes Saved',
}, action) => {
  switch (action.type) {
    case API_INITIATE_GET_SSM_CUSTOMER_DATA:
      return { ...state, loading: true, dataLoaded: false, siteFormSubmitted: false };
    case API_COMPLETE_GET_SSM_CUSTOMER_DATA: {
      return {
        ...state,
        loading: false,
        customerAccountNumbers: action.data.customerAccountNumbers,
        customerAccountName: action.data.customerAccountName,
        customerFirstName: action.data.customerFirstName,
        customerLastName: action.data.customerLastName,
        customerContactPhone: action.data.customerContactPhone,
        cwpBanner: action.data.cwpBanner !== undefined ? action.data.cwpBanner : false,
        sitesData: action.data.sitesData,
        virtualServicesPresent: action.data.virtualServicesPresent,
        isdnProduct: action.data.isdnProduct,
        dataLoaded: true,
      };
    }
    case API_INITIATE_SUBMIT_SSM_CUSTOMER_DATA: {
      return {
        ...state,
        loading: true,
        dataLoaded: false,
        siteFormSubmitted: false,
      };
    }
    case API_COMPLETE_SUBMIT_SSM_CUSTOMER_DATA: {
      return {
        ...state,
        loading: false,
        dataLoaded: false,
        siteFormSubmitted: true,
        referenceNumber: action.data.referenceNumber,
      };
    }
    case API_COMPLETE_SUBMIT_SSM_SITE_CUSTOMER_DATA: {
      return {
        ...state,
        loading: false,
        dataLoaded: true,
        siteFormSubmitted: true,
        referenceNumber: action.data.referenceNumber,
        siteIdSubmitted: action.data.siteId,
      };
    }
    case API_INITIATE_AUTO_SAVE: {
      return {
        ...state,
        autoSaveStatus: 'saving',
      };
    }
    case API_COMPLETE_AUTO_SAVE: {
      return {
        ...state,
        autoSaveStatus: 'saved',
      };
    }
    case INITIATE_ISDN_CALLBACK_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case COMPLETE_ISDN_CALLBACK_REQUEST: {
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
};

// Map & Connect
export const mapStateToProps = state => ({
  customerAccountNumbers: state.ssmHomePageReducer.customerAccountNumbers,
  customerAccountName: state.ssmHomePageReducer.customerAccountName,
  customerContactPhone: state.ssmHomePageReducer.customerContactPhone,
  sitesData: state.ssmHomePageReducer.sitesData,
  virtualServicesPresent: state.ssmHomePageReducer.virtualServicesPresent,
  authorableContent: state.authorableContentReducer.authorableContent,
  customerFirstName: state.ssmHomePageReducer.customerFirstName,
  dataLoaded: state.ssmHomePageReducer.dataLoaded,
  siteFormSubmitted: state.ssmHomePageReducer.siteFormSubmitted,
  referenceNumber: state.ssmHomePageReducer.referenceNumber,
  isdnProduct: state.ssmHomePageReducer.isdnProduct,
  siteIdSubmitted: state.ssmHomePageReducer.siteIdSubmitted,
  autoSaveStatus: state.ssmHomePageReducer.autoSaveStatus,
  cwpBanner: state.ssmHomePageReducer.cwpBanner,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    submitSSMCustomerData,
    submitAutoSaveData,
    submitIsdnRequestCallback,
  }, dispatch),
});

const SSMHomePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);


export default SSMHomePage;
